/**
 * ThumbnailFallback Component
 * Displays a placeholder when image loading fails
 * Maintains dimensions and layout consistency
 */

import React from 'react'

import { NEWS_UPDATES_CONSTANTS } from './constants'
import ThumbnailSvg from '../../assets/homepage/ThumbnailSvg.png'
export interface ThumbnailFallbackProps {
  title?: string
  className?: string
}
const ThumbnailFallback = React.memo<ThumbnailFallbackProps>(({ title, className = '' }) => {
  return (
    <div
      className={`
          ${NEWS_UPDATES_CONSTANTS.THUMBNAIL.WIDTH}
          ${NEWS_UPDATES_CONSTANTS.THUMBNAIL.HEIGHT}
          ${NEWS_UPDATES_CONSTANTS.THUMBNAIL.PADDING}
          ${NEWS_UPDATES_CONSTANTS.THUMBNAIL.ROUNDED}
          bg-gradient-to-br from-gray-100 to-gray-200
          flex items-center justify-center
          ${className}
        `}
      role="img"
      aria-label={`Placeholder for ${title}`}
    >
      <div className="flex flex-col items-center justify-center gap-2">
        <img src={ThumbnailSvg} alt="Thumbnail placeholder" className="w-12 h-12 object-contain" />
        <span className="text-xs text-gray-500 font-medium">Image unavailable</span>
      </div>
    </div>
  )
})

ThumbnailFallback.displayName = 'ThumbnailFallback'

export default ThumbnailFallback
